import React from "react";
import NumericInput from "../../../../../misc-components/NumericInput";

import ErrorWrapper from "../../../../ErrorWrapper";
import { Minutes } from "../../../../../../../domain/units/Minutes";
import {
  useSingleFormItem,
  UseSingleFormItemProps,
} from "../../../../useSingleFormItem";
import { FormItemProps } from "../../../../FormItem";

type Props =
  {
    decimal: boolean,
  }
  & UseSingleFormItemProps<number, Minutes>
  & FormItemProps<Minutes>;

const MinutesInput: React.FC<Props> = (props) => {
  const hook = useSingleFormItem(props);

  return (
    <ErrorWrapper
      isError={hook.isError}
      errors={hook.error}
    >
      <NumericInput
        addonAfter={"\""}
        placeholder="Minutes"
        className={hook.isError ? "error" : undefined}
        value={hook.input}
        onChange={hook.onInputChange}
        integersOnly={!props.decimal}
        separateThousands={false}
        allowNegative={false}
        returnUndefinedOnEmpty={true}
      />
    </ErrorWrapper>
  );
};

export default MinutesInput;